import React from "react";
import styled from "styles/styled_components";

import Icon, { ICON_TYPE, ICON_COLOR } from "components/shared/icon";

const StyledCheckboxWithLabel = styled.div`
  position: relative;
`;

interface ICheckboxLabelProps {
  disabled: boolean;
}

const StyledCheckboxLabel = styled("label")<ICheckboxLabelProps>`
  color: ${props =>
    props.disabled
      ? props.theme.text.color.medium
      : props.theme.text.color.dark};
  font-family: ${props => props.theme.text.primaryFamily};
  padding-left: 5px;
`;

interface ICheckboxStyleProps {
  checked: boolean;
  disabled: boolean;
  isInclusive: boolean;
  hasUncheckedChildren: boolean;
}

const StyledCheckbox = styled("input")<ICheckboxStyleProps>`
  appearance: none;
  background-color: ${props => {
    const { isInclusive, disabled, hasUncheckedChildren, theme } = props;
    if (isInclusive && disabled) {
      return theme.colors.dsGrayLight;
    } else if (hasUncheckedChildren) {
      return theme.colors.lspdBlue500;
    } else {
      return theme.colors.brandWhite;
    }
  }};
  border: ${props =>
    props.disabled
      ? props.theme.lightBorder
      : `1px solid ${props.theme.colors.dsBlueDark}`};
  height: 14px;
  width: 14px;
  position: relative;
  top: 5px;

  &:checked {
    background-color: ${props => props.theme.colors.lspdBlue500};
    position: relative;
    top: 5px;
  }
`;

const StyledIconWrapper = styled.span`
  position: absolute;
  left: 4px;
  top: 7px;
  opacity: 1;
`;

interface ICheckbox {
  label: string;
  checked: boolean;
  onChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlurHandler?: () => void;
  disabled?: boolean;
  hasUncheckedChildren?: boolean;
  isInclusive?: boolean;
}

function CheckboxWithLabel({
  label,
  checked,
  onChangeHandler,
  onBlurHandler,
  disabled = false,
  isInclusive = false,
  hasUncheckedChildren = false,
}: ICheckbox) {
  const iconType = hasUncheckedChildren
    ? ICON_TYPE.MINUS_SIGN
    : ICON_TYPE.CHECKMARK;

  return (
    <StyledCheckboxWithLabel
      key={label}
      className="checkbox-option"
      title={hasUncheckedChildren ? "Some children are selected." : undefined}>
      <StyledCheckbox
        isInclusive={isInclusive}
        disabled={disabled}
        hasUncheckedChildren={hasUncheckedChildren}
        type="checkbox"
        id={label}
        checked={checked}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
      />
      <StyledCheckboxLabel
        className="checkbox-label"
        disabled={disabled}
        htmlFor={label}>
        {label}
        {(checked || hasUncheckedChildren) && (
          <StyledIconWrapper>
            <Icon size="12px" color={ICON_COLOR.WHITE} type={iconType} />
          </StyledIconWrapper>
        )}
      </StyledCheckboxLabel>
    </StyledCheckboxWithLabel>
  );
}

export default CheckboxWithLabel;
